import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaVideo,
  FaBookOpen,
  FaEye,
  FaRocket,
  FaUsers,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const CreativeStorytellingVideoServicesInDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Creative Storytelling Video Services in Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Inspire Your Audience</Subheading>}
        heading={
          <Heading>
            Creative{" "}
            <span tw="text-primary-500">Storytelling Video Services</span> in
            Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we offer creative storytelling video services in
            **Dubai**, producing captivating, narrative-driven videos that
            engage audiences and convey powerful messages. Let us bring your
            story to life with cinematic flair.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1504674900247-0877df9cc836?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1616763355548-1b606f439f86?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1578270599559-c4342f371da5?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Tell Your Story"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Masterful Storytelling in Dubai"
        description="We craft videos that inspire and connect."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Cinematic Quality",
            description:
              "Visually stunning videos with professional production.",
          },
          {
            icon: <FaBookOpen color="#ff5464" size={40} />,
            title: "Compelling Narratives",
            description: "Stories that resonate and leave an impact.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Audience Engagement",
            description: "Videos designed to captivate viewers.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Turnaround",
            description: "Timely delivery with uncompromised quality.",
          },
          {
            icon: <FaUsers color="#ff5464" size={40} />,
            title: "Creative Collaboration",
            description: "A team dedicated to your vision.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted by Clients",
            description: "Dubai’s choice for storytelling videos.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Storytelling Process"
        description={
          <Description>
            We create storytelling videos with a refined approach:
            <ul tw="mt-4 list-disc pl-6">
              <li>Discovery: Understand your story and goals.</li>
              <li>Scripting: Develop engaging narratives and storyboards.</li>
              <li>Filming: Capture footage with top-tier equipment.</li>
              <li>Editing: Enhance with visuals, sound, and effects.</li>
              <li>Review: Refine to match your creative vision.</li>
              <li>Delivery: Provide a polished video ready to inspire.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1580537659466-0a9bfa916a54?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1533561797500-4fad4750814e?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Storytelling Triumphs in Dubai"
        description="Our videos have moved and motivated audiences."
        cards={[
          {
            icon: <FaBookOpen color="#ff5464" size={40} />,
            title: "Emotional Impact",
            description: "Increased audience connection by 45%.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Brand Resonance",
            description: "Amplified storytelling for a Dubai brand.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Satisfaction",
            description: "96% approval from creative clients.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Share Your Story?</Subheading>}
        heading="Creative Storytelling in Dubai"
        description={
          <Description>
            Partner with MilaajBrandset for creative storytelling video services
            in Dubai. Produce engaging, narrative-driven videos that
            inspire—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1533928298208-27ff66555d8d?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1576097449798-7c7f90e1248a?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1607464778129-304750d0b10b?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
